import { Breadcrumb } from "@/components/ui/breadcrumbs";
import { Section } from "../components/Section";
import { WorkflowDetailForm } from "../components/workflows/WorkflowDetailForm";

export function NewWorkflowPage() {
  return (
    <>
      <Section.Title
        breadcrumb={
          <>
            <Breadcrumb href={{ to: "/admin/workflows" }}>Rules</Breadcrumb>
            <Breadcrumb>New</Breadcrumb>
          </>
        }
      >
        New rule
      </Section.Title>
      <WorkflowDetailForm />
    </>
  );
}
